/*
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-03-21 11:34:22
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-06 16:14:28
 * @FilePath: /jy-dashboard-web/src/util/router.js
 * @Description: vue-router相关配置
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import systemLogin from '@/pages/system-login.vue'
import statusInfo from '@/pages/status-info.vue'

const routes = [
  {
    path: '/',
    redirect: '/company-profile'
  },
  // 登录页面
  {
    path: '/system-login',
    name: 'systemLogin',
    component: systemLogin
  },
  // 大屏1
  {
    path: '/company-profile',
    name: 'companyProfile',
    component: () => import(/* webpackChunkName: "company-profile" */'@/pages/company-profile.vue')
  },
  // 大屏2
  {
    path: '/production-management',
    name: 'productionManagement',
    component: () => import(/* webpackChunkName: "production-management" */'@/pages/production-management.vue')
  },
  // 状态信息页面
  {
    path: '/status-info/:code',
    name: 'statusInfo',
    component: statusInfo
  },
  // 未知路由
  {
    path: '/:pathMatch(.*)*',
    redirect: '/status-info/404'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
